<img class="eft__check-example" src="/administrator/components/com_mcform/assets/images/sample_check_routing_number.gif" />
